'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bots = require('./bots.info');

var _bots2 = _interopRequireDefault(_bots);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  info: _bots2.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/slack/methods/bots.js
// module id = 424
// module chunks = 0